<template>
	<span
		:class="{
			'text-primary': data.mutation === 'credit',
			'text-danger': data.mutation === 'debit',
		}"
		v-if="data.value !== 0">
		<b class="va-m">{{ formatNumberPlain(data.value) }}</b>
		<i class="material-icons va-m" v-if="data.mutation === 'credit'">arrow_drop_up</i>
		<i class="material-icons va-m" v-else>arrow_drop_down</i>
	</span>
	<span v-else-if="data.value === 0"><b class="va-m">0</b></span>
	<span v-else>-</span>
</template>

<script>
export default {
	name: 'MutationValue',
	props: {
		data: {
			type: Object,
		},
	},
};
</script>
